import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const EmailSubjectLine = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14953)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#ECF2FF"
          />
          <path
            d="M130.023 107.117C130.306 113.844 132.522 120.347 136.405 125.846H109.59C113.47 120.345 115.684 113.843 115.967 107.117H130.023Z"
            fill="#E3E3E3"
          />
          <path
            d="M176.846 93.0703V102.435C176.846 103.677 176.353 104.868 175.475 105.746C174.597 106.624 173.406 107.117 172.164 107.117H73.8359C72.5941 107.117 71.4031 106.624 70.525 105.746C69.6469 104.868 69.1536 103.677 69.1536 102.435V93.0703H176.846Z"
            fill="white"
          />
          <path
            d="M176.846 22.836V93.0704H69.1536V22.836C69.1536 21.5942 69.6469 20.4032 70.525 19.5251C71.4031 18.647 72.5941 18.1537 73.8359 18.1537H172.164C173.406 18.1537 174.597 18.647 175.475 19.5251C176.353 20.4032 176.846 21.5942 176.846 22.836Z"
            fill="#66E1FF"
          />
          <path
            d="M69.1536 22.836V93.0704H89.5918L164.508 18.1537H73.8359C72.5941 18.1537 71.4031 18.647 70.525 19.5251C69.6469 20.4032 69.1536 21.5942 69.1536 22.836Z"
            fill="#C2F3FF"
          />
          <path
            d="M144.061 41.5651H101.92C100.679 41.5651 99.4875 42.0584 98.6094 42.9365C97.7313 43.8146 97.238 45.0055 97.238 46.2474V69.6588C97.238 70.9006 97.7313 72.0916 98.6094 72.9697C99.4875 73.8478 100.679 74.3411 101.92 74.3411H144.061C145.303 74.3411 146.494 73.8478 147.372 72.9697C148.25 72.0916 148.743 70.9006 148.743 69.6588V46.2474C148.743 45.0055 148.25 43.8146 147.372 42.9365C146.494 42.0584 145.303 41.5651 144.061 41.5651Z"
            fill="#E3E3E3"
          />
          <path
            d="M101.93 41.5651C100.688 41.5651 99.4969 42.0584 98.6188 42.9365C97.7407 43.8146 97.2474 45.0055 97.2474 46.2474V69.6588C97.2474 70.9006 97.7407 72.0916 98.6188 72.9697C99.4969 73.8478 100.688 74.3411 101.93 74.3411H108.321L141.097 41.5651H101.93Z"
            fill="white"
          />
          <path
            d="M144.07 41.5651H101.93C100.688 41.5651 99.4969 42.0584 98.6188 42.9365C97.7407 43.8146 97.2474 45.0055 97.2474 46.2474V69.6588C97.2474 70.9006 97.7407 72.0916 98.6188 72.9697C99.4969 73.8478 100.688 74.3411 101.93 74.3411H144.07C145.312 74.3411 146.503 73.8478 147.381 72.9697C148.259 72.0916 148.753 70.9006 148.753 69.6588V46.2474C148.753 45.0055 148.259 43.8146 147.381 42.9365C146.503 42.0584 145.312 41.5651 144.07 41.5651Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.2474 48.5885L118.318 59.3578C119.741 60.1797 121.356 60.6124 123 60.6124C124.644 60.6124 126.259 60.1797 127.682 59.3578L148.753 48.5885"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M109.599 125.846C113.479 120.345 115.693 113.843 115.977 107.117"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M136.401 125.846C132.521 120.345 130.307 113.843 130.023 107.117"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.93 125.846H144.07"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M69.1536 93.0703H176.846"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M172.164 18.1537H73.8359C72.5941 18.1537 71.4031 18.647 70.525 19.5251C69.6469 20.4032 69.1536 21.5942 69.1536 22.836V102.435C69.1536 103.677 69.6469 104.868 70.525 105.746C71.4031 106.624 72.5941 107.117 73.8359 107.117H172.164C173.406 107.117 174.597 106.624 175.475 105.746C176.353 104.868 176.846 103.677 176.846 102.435V22.836C176.846 21.5942 176.353 20.4032 175.475 19.5251C174.597 18.647 173.406 18.1537 172.164 18.1537Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44 28C44 27.4477 44.4477 27 45 27H117C117.552 27 118 27.4477 118 28V44.7001C118 45.2523 117.552 45.7001 117 45.7001H45C44.4477 45.7001 44 45.2523 44 44.7001V28Z"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="2"
          />
          <path
            d="M48.3929 33.354V32.3735C48.3929 32.1134 48.4962 31.864 48.6801 31.6801C48.864 31.4962 49.1134 31.3929 49.3735 31.3929H56.2372C56.4972 31.3929 56.7466 31.4962 56.9305 31.6801C57.1144 31.864 57.2177 32.1134 57.2177 32.3735V33.354"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M52.8049 31.3928V40.2176"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.8445 40.2177H54.7667"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M59.8872 40.7083H68.603"
            stroke="#1E1E1E"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14953">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
